import { TableColumnsType, Tag } from "antd";
import { Inventary } from "../../Models/Inventary";
import { Image } from 'antd';
import { FaEye } from 'react-icons/fa6';
const columns: TableColumnsType<Inventary> = [
    {
    dataIndex: 'image',
    title: 'Imagen',
    render: (_, record) => (
                <Image 
                style={{
                  width:"50px"
                }}
            src={record.product.image_url}
            alt={`Producto ${record.product.name}`}
            preview={{
            mask: <FaEye />, }} 
            />
    ),
  },
  {
    dataIndex: 'title',
    title: 'Name',
    render: (_, record) => (
      <span>{record.product.card_id} - {record.product.pokemonCard[0].name} ({record.product.language} - {record.product.card_type})</span>
    ),
  },
  {
    dataIndex: 'detalle',
    title: 'Detalle',
    render: (_, record) => (
      <>
      <Tag style={{ marginInlineEnd: 0 }} color="cyan">
        {/* {tag.toUpperCase()} */}
        {record.product.pokemonCard[0].sets.name}
      </Tag>
        <Tag style={{ marginInlineEnd: 0 }} color="gold">
        {/* {tag.toUpperCase()} */}
        {record.product.pokemonCard[0].rarity}
      </Tag>
      </>
    ),
  },
  {
    dataIndex: 'cantidad',
    title: 'Cantidad',
        render: (_, record) => (
      <span>{record.quantity}</span>
    ),
  },
    {
    dataIndex: 'precio',
    title: 'Precio Unidad',
        render: (_, record) => (
          <div style={{display:"flex", flexDirection:"column", flexWrap:"wrap", gap:"3px"}}>
          <span>${record.product.price} BCV</span>
          <span>${record.product.cash_price} CASH</span>


          </div>
    ),
  },
];

export default columns